import styled from '@emotion/styled';
import React from 'react';
import { createPortal } from 'react-dom';

import ActionButton from '../ActionButton/ActionButton';
import { useI18n } from '../../../hooks/useI18n';
import { TranslationKeys } from '../../../i18n/locales/defaultResources';
import CloseButton from '../CloseButton/CloseButton';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled.div`
  background: #f5f7fa;
  color: #00223c;
  padding: 24px;
  border-radius: 8px;
  width: 430px;
  height: 272px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: #323f4b;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: -0.5px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: right;
  gap: 10px;
`;

interface ModalProps {
  isOpen: boolean;
  onCloseConfirm: () => void;
  onCloseDecline: () => void;
}

const ClosingConfirmationModal: React.FC<ModalProps> = ({
  isOpen,
  onCloseConfirm,
  onCloseDecline,
}) => {
  const { t } = useI18n();

  if (!isOpen) return null;

  const modalContent = (
    <ModalOverlay onClick={onCloseDecline}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <h1>{t(TranslationKeys.upload_banner_closing_confirmation_title)}</h1>
          <CloseButton onClick={onCloseDecline} />
        </ModalHeader>
        <ModalBody>
          <p>
            <b>
              {t(TranslationKeys.upload_banner_closing_confirmation_question)}
            </b>
          </p>
          <p>
            {t(TranslationKeys.upload_banner_closing_confirmation_information)}
          </p>
        </ModalBody>
        <ModalFooter>
          <ActionButton
            variant="close"
            buttonText={t(
              TranslationKeys.upload_banner_closing_confirmation_cancel_button
            )}
            onClickAction={onCloseConfirm}
          />
          <ActionButton
            variant="accept-blue"
            buttonText={t(
              TranslationKeys.upload_banner_closing_confirmation_continue_button
            )}
            onClickAction={onCloseDecline}
          />
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );

  return createPortal(modalContent, document.body);
};

export default ClosingConfirmationModal;
